import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

class ErrorBoundary extends React.Component {
  constructor(p){super(p);this.state={err:null};}
  static getDerivedStateFromError(e){return{err:e};}
  render(){
    if(this.state.err) return(
      <div style={{padding:32,fontFamily:"monospace",background:"#FEF2F2",minHeight:"100vh"}}>
        <div style={{fontWeight:700,fontSize:16,color:"#DC2626",marginBottom:12}}>Errore applicazione:</div>
        <pre style={{fontSize:12,color:"#7F1D1D",whiteSpace:"pre-wrap",wordBreak:"break-all"}}>
          {this.state.err?.message}{"\n\n"}{this.state.err?.stack}
        </pre>
      </div>
    );
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<ErrorBoundary><App /></ErrorBoundary>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorkerRegistration.register({
  onUpdate: registration => {
    registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
    window.location.reload();
  },
});
reportWebVitals();
